import React from 'react'
import * as BuilderSVG from '../../../../assets/icons/builder'
import * as StandardSVG from '../../../../assets/icons'
import type {UIElementType} from '../../../../common/types'

export type BuilderIconName = keyof typeof BuilderSVG
export const BuilderIcon = ({iconName}: {iconName: BuilderIconName}) => {
  if (!(iconName in BuilderSVG)) {
    console.warn(`Icon ${iconName} not found`)
  }

  const SVGIcon = BuilderSVG[iconName]
  return SVGIcon ? <SVGIcon /> : null
}

export type StandardIconName = keyof typeof StandardSVG
export const StandardIcon = ({iconName}: {iconName: StandardIconName}) => {
  if (!(iconName in StandardSVG)) {
    console.warn(`Icon ${iconName} not found`)
  }

  const SVGIcon = StandardSVG[iconName]
  return SVGIcon ? <SVGIcon /> : null
}

export const getIconNameForElement = (
  type: UIElementType | string
): BuilderIconName => {
  switch (type) {
    case 'alert':
      return 'Alert'
    case 'text':
      return 'String'
    case 'headline':
      return 'Headline'
    case 'imageBanner':
      return 'Media'
    case 'videoBanner':
      return 'VideoBanner'
    case 'video':
      return 'Video'
    case 'list':
      return 'List'
    case 'stepper':
      return 'Stepper'
    case 'switch':
      return 'Boolean'
    case 'dropdown':
      return 'Dropdown'
    case 'linkButton':
      return 'Link'
    case 'submitButton':
      return 'Submit'
    case 'image':
      return 'Image'
    case 'dismissButton':
      return 'DismissButton'
    case 'snoozeButton':
      return 'SnoozeButton'
    case 'voteUpButton':
      return 'VoteUpButton'
    case 'voteDownButton':
      return 'VoteDownButton'
    case 'datePicker':
      return 'Date'
    case 'textInput':
      return 'TextInput'
    case 'numberInput':
      return 'Number'
    case 'arrowLeft':
      return 'ArrowLeft'
    case 'click':
      return 'Click'
    // case 'buttonGroup':
    // case 'radioGroup':
    // case 'imageList':
    // case 'checkbox':
    default:
      return 'String'
  }
}
